<style>

  #application_icon {
    margin-left: 20px;
    color: rgb(0, 102, 255);
  }

  #logged_username {
    margin-left: 10px;
    margin-right: 10px;
    font-size: small;
  }

  #logout-button {
    margin-right: 20px;
    color: red;
    border-radius: 5px;
    padding: 10px;
  }
  
</style>

<script setup>
import { RouterView } from "vue-router";
import { useKeycloak } from '@josempgon/vue-keycloak'
</script>

<template>
   <v-layout class="rounded rounded-md">
    <v-app-bar>
      <template v-slot:prepend>
        <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </template>
      <v-icon id="application_icon">mdi mdi-gavel</v-icon>
      <v-toolbar-title>Laghezza Customs Litigations</v-toolbar-title> 
      <span id="logged_username">Username: <b>{{ username }}</b></span>
      <v-btn variant="tonal" @click="logout" id="logout-button" icon="mdi-logout" size="small"></v-btn>
    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        :location="$vuetify.display.mobile ? 'bottom' : undefined"
        temporary>
      <v-list v-model:opened="openMenu">

        <v-list-group value="menu_1">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              title="Funzionalità"
            ></v-list-item>
          </template>
          <v-list-item :to="{ path: '/litigations' }">
            <v-list-item-title>Contenziosi/Revisioni</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <RouterView />
    </v-main>
   </v-layout>
  
</template>

<script>
  const { token, username, userId, roles, resourceRoles } = useKeycloak()
  export default {
    data: () => ({
      drawer: false,
      openMenu: ["menu_1"],
      user: null
    }),
    mounted() {
      document.title = "Laghezza Customs Litigations";
      return { token, username, userId, roles, resourceRoles }
    },
    methods: {
      logout() {
        this.$keycloak.logout();
      }
    }
  }
</script>
